import React, { ReactNode } from 'react';
import { Pane } from 'evergreen-ui';
import styles from '../TargetGroupSettings.module.css';

interface TabPanelProps {
    tab: string;
    index: number;
    selectedIndex: number;
    children: ReactNode;
}

/**
 * Shared wrapper for the contents of each tab in TargetGroupSettings.
 * Replicates the original Pane shell (key, ARIA attrs, conditional display)
 * so individual tab components don't have to repeat that boilerplate.
 */
export const TabPanel = ({ tab, index, selectedIndex, children }: TabPanelProps) => (
    <Pane
        key={tab}
        id={`panel-${tab}`}
        role="tabpanel"
        aria-labelledby={tab}
        aria-hidden={index !== selectedIndex}
        className={styles.target_group_settings__pane__configuration}
        display={index === selectedIndex ? 'block' : 'none'}>
        {children}
    </Pane>
);

export default TabPanel;
